import { useContext } from "react";
import { RCL } from "../../components/RCL";
import { Row, Cell, Card, Icon } from "@sunwing/components";
import config from "../../app/config";
import { cloudinaryImage } from "../../utils/cloudinary";
import { Link } from 'react-router-dom';
import { RCLContext } from "../../components/RCL/RCLProvider";
import { VWQIcon } from "@sunwing/icons";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./GridPageVwq.module.scss");
  } else {
    styles = await import("./GridPage.module.scss");
  }
})();

const ItemList = (props) => {
    const { locale } = useContext(RCLContext);
          
    return (
     <div>
        <Row cols={3}>
        {props.items && props.items.length > 0 && 
            props.items.map(
            (gridPageItem) =>
              gridPageItem?.imageAsset !== null && (
                <Cell key={gridPageItem.title}>
                <Card>
                    <Card.Image
                    className={styles.gridPageImage}
                    src={cloudinaryImage(
                        gridPageItem?.imageAsset?.[0]?.public_id,
                        {
                        width: 747,
                        }
                    )}
                    alt="placeholder alt"
                    />
                    <Card.Body className={styles.gridPageCardContainer}>
                    <Card.Header
                        className={styles.gridPageHeading}
                        as="h5"
                    >
                        {gridPageItem.title.length > 50 ? 
                        gridPageItem.title.substring(0, 50) + " ..." : 
                        gridPageItem.title}
                    </Card.Header>
                    {gridPageItem.description && gridPageItem.description.length > 0 && (
                        <div className={ styles.gridPageDesc}>
                        {gridPageItem.description}
                        </div>
                    )}
                    {gridPageItem.landingPage && gridPageItem?.landingPage?.sys.id && (
                        <Link
                        className={ styles.gridPageLandingPageLink}
                        target="_blank"
                        to={`/${locale}/LandingPage?brand=${config.brand}&slug=${gridPageItem?.landingPage?.slug}`}
                        >
                        {gridPageItem?.landingPage?.landingPageLinkText}
                        <VWQIcon
                            className={styles.gridPageLandingPageLinkIcon}
                            name="arrow-right-micro"
                            aria-hidden="true"
                        />
                        </Link>
                    )}
                    {gridPageItem.pageLink && gridPageItem?.pageLink?.sys.id && (
                        <Card.Link
                        className={styles.gridPageLandingPageLink}
                        target="_blank"
                        to={gridPageItem.pageLink.url}
                        >
                        {gridPageItem.pageLink.linkText}
                        <Icon
                            className={styles.gridPageDownloadLink}
                            name="download"
                            aria-hidden="true"
                        />
                        </Card.Link>
                    )}
                    {gridPageItem.fileCollection.items[0] !==null
                    && gridPageItem.fileCollection.items[0]
                    && (
                        <Card.Link
                        className={styles.gridPageLink}
                        target="_blank"
                        to={
                            !gridPageItem.fileCollection.items[0]
                            ? ""
                            : gridPageItem.fileCollection.items[0]
                                .url
                        }
                        >
                        {config.isWestJetMode ? 
                            <>
                            {RCL({ searchKey: "AgentTools_Download" })}
                            <VWQIcon
                                className={styles.gridPagePlayLink}
                                name="arrow-right-micro"
                                aria-hidden="true"
                            />
                            </>
                            : 
                            <>
                            <Icon
                                className={styles.gridPageDownloadLink}
                                name="download"
                                aria-hidden="true"
                            />
                            {RCL({ searchKey: "AgentTools_Download" })}
                            </>
                        }                           
                        </Card.Link>
                    )}
                    </Card.Body>
                </Card>
                </Cell>
            )
        )}
        </Row>
    </div>
    );
}

export default ItemList;
export { ItemList };